import React, { Fragment } from 'react';

const PhoneButton = ({ handleClick }) => {
  return (
    <Fragment>
      <button className="phone-button">+7 3952 33 88 55</button>
      <a href="tel:+7 3952 33 88 55" className="phone-button-mobile">
        <svg width="18px" height="22px">
          <use href="#phone"></use>
        </svg>
      </a>
    </Fragment>
  );
};

export default PhoneButton;
